import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoggerService } from './logger.service';
import { environment } from 'src/environments/environment';


@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
    constructor(private logger: LoggerService,
        private router: Router,

    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = sessionStorage.getItem("accessToken")

        this.logger.log(currentUser)
        if (currentUser) {

            this.logger.log("here")
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        // this.router.navigate([environment.commonLoginUrl]);
        this.router.navigate(['/login']);

        return false;
    }
}
